import { ErrorToast } from '../../shared';
import axios from '../axiosCall'
import Urls from "../endpoints";
import { ICreateDiscount, IGetDiscountCodes } from '../modelAPI/discount';
import { IData, IGetDiscountCodesResponse } from '../resultAPI/getDiscountCodes';
import { IGetDiscountSRV } from '../resultAPI/getDiscountSRV';



export const getDiscountCodes = (obj: IGetDiscountCodes) => {
    return axios.post<IGetDiscountCodesResponse>(Urls.getDiscountCodes(), obj)
}
export const getDetailDiscount = (id: string) => {
    return axios.get<IData>(Urls.couponDetails(id))
}
export const disableDiscount = (id:string) => {
    return axios.post<boolean>(Urls.disableCoupon(id))
}
export const enableDiscount = (id:string) => {
    return axios.post<boolean|string>(Urls.enableCoupon(id))
}
export const extendDiscount = (id:string, date:string) => {
    return axios.patch<boolean|string>(Urls.extendCoupon(id, date))
}
export const createDiscount = (obj:ICreateDiscount) => {
    return axios.post<boolean>(Urls.createCoupons(), obj)
}
export const getDiscountSRV = (type:number) => {
    return axios.get<IGetDiscountSRV>(Urls.getDiscountServices(type))
}

